<template>
  <div class="account-owner__edit-wrapper card">
    <page-header
      title="Account Owner"
      breadcrumbText="Dashboard >> Settings >> Account Profile >> Edit Information"
    />
    <div class="security-details-form">
      <div class="security-details-form__header cursor-pointer">
        <div>
          <p class="text-secondary-orange font-semibold">
            Security Details
          </p>
        </div>
      </div>
      <div class="advanced-details-form">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12 input-col">
              <div class="advanced-details__form-input-wrapper">
                <label class="label">Old Password</label>
                <div class="password-input-field_wrapper">
                  <div
                    class="view-password"
                    @click="showPassword('old-password')"
                    v-if="security.old.length > 0"
                  >
                    <show-password-icon />
                  </div>
                  <input
                    type="password"
                    id="old-password"
                    class="input"
                    v-model="security.old"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-12 input-col">
              <div class="advanced-details__form-input-wrapper">
                <label class="label">New Password</label>
                <div class="password-input-field_wrapper">
                  <div
                    class="view-password"
                    @click="showPassword('password')"
                    v-if="security.password.length > 0"
                  >
                    <show-password-icon />
                  </div>
                  <input
                    type="password"
                    id="password"
                    class="input"
                    v-model="security.password"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-12 input-col">
              <div class="advanced-details__form-input-wrapper">
                <label class="label">Confirm New Password</label>
                <div class="password-input-field_wrapper">
                  <div
                    class="view-password"
                    @click="showPassword('confirm-password')"
                    v-if="passwordConfirmation.length > 0"
                  >
                    <show-password-icon />
                  </div>
                  <input
                    type="password"
                    id="confirm-password"
                    class="input"
                    v-model="passwordConfirmation"
                  />
                </div>
                <small class="text-red font-semibold" v-if="!passwordsMatch"
                  >Passwords don't match!</small
                >
              </div>
            </div>
            <div class="pl-0 col-md-4 col-lg-4 col-12 mb-0 input-col">
              <div class="advanced-details__form-input-wrapper">
                <label class="label">Security Question</label>
                <el-select v-model="security.securityques" placeholder="Select">
                  <el-option
                    v-for="question in securityQuestions"
                    :key="question.id"
                    :label="question.privilege"
                    :value="question.privilege"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="pl-0 col-md-4 col-lg-4 col-12 mb-0 input-col">
              <div class="advanced-details__form-input-wrapper">
                <label class="label">Answer</label>
                <input type="text" class="input" v-model="security.answer" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr" />
      <div class="two-factor-auth">
        <div class="two-factor-auth__header">
          <p class="font-semibold text-secondary-orange">
            Enable Two - Factor Authentication?
          </p>
        </div>
        <div class="radio-buttons">
          <div class="radio-option">
            <label for="enable" class="radio-label">
              <input
                type="radio"
                id="enable"
                :value="true"
                v-model="security.twoFA"
              />
              Enable
              <span></span>
            </label>
          </div>
          <div class="radio-option">
            <label for="disable" class="radio-label">
              <input
                type="radio"
                id="disable"
                :value="false"
                v-model="security.twoFA"
              />
              Disable
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <button
          class="button button-secondary button-long"
          @click="$router.go(-1)"
        >
          Cancel
        </button>
        <button
          class="button button-primary button-long"
          :disabled="disableButton"
          @click="updateSecuritySettings"
        >
          <button-loader v-if="updating" /> <span v-else>Save</span>
        </button>
      </div>
    </div>

    <!-- <two-factor-auth-modal
      :show-modal="isTwoFactorModal"
      @close-modal="isTwoFactorModal = false"
      @user-verified="twoFactorEnabled = true"
    /> -->
  </div>
</template>

<script>
// import TwoFactorAuthModal from "@/SecurityPolicy/TwoFactorAuthentication/TwoFactorAuthModal";
export default {
  components: {
    // TwoFactorAuthModal,
  },
  data() {
    return {
      twoFactorAuthOption: null,
      security: {
        twoFA: false,
        securityques: "",
        answer: "",
        password: "",
        old: "",
      },
      securityQuestions: [],
      updating: false,
      passwordConfirmation: "",
      passwordsMatch: true,
      isTwoFactorModal: false,
      twoFactorEnabled: false,
    };
  },
  computed: {
    disableButton() {
      let disableButton = this.shouldDisableButton(this.security);
      if (!this.passwordsMatch || disableButton) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    passwordConfirmation(val) {
      if (val != this.security.password) {
        this.passwordsMatch = false;
      } else {
        this.passwordsMatch = true;
      }
    },
  },
  mounted() {
    this.getSecurityQuestions();
  },
  methods: {
    async updateSecuritySettings() {
      this.updating = true;
      // let payload = {};
      // payload.password = this.security.password;
      let userId = localStorage.getItem("userId");
      this.security.userId = userId;
      try {
        let response = await this.$_updateSecuritySettings(this.security);
        this.logResponse(response);
        this.generateToast(
          "Security Settings successfully updated!",
          "success"
        );
        this.resetInputFields();
        this.updating = false;
      } catch (error) {
        this.handleError(error);
        this.updating = false;
      }
    },
    async getSecurityQuestions() {
      try {
        let response = await this.$_getSecurityQuestions();
        console.log(response);
        this.securityQuestions = response.data.allQuestions;
      } catch (error) {
        this.handleError(error);
      }
    },
    resetInputFields() {
      this.security = {
        twoFA: this.security.twoFA,
        securityques: "",
        answer: "",
        password: "",
        old: "",
      };
      this.passwordConfirmation = "";
    },
    showPassword(passwordField) {
      var password = document.getElementById(passwordField);
      if (password.type === "password") {
        password.type = "text";
      } else {
        password.type = "password";
      }
    },
  },
};
</script>

<style scoped>
.security-details-form__header {
  padding: 1.5rem 0;
}
.input-col {
  padding-right: 0.5rem !important;
  padding-left: 0 !important;
  margin-bottom: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input-field {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
.button-wrapper {
  padding: 2rem 0;
}
.advanced-details-form__main {
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
}
.advanced-details-form__main.show {
  height: auto;
}
.radio-buttons {
  padding: 1rem 0;
  display: flex;
}
.radio-option {
  padding-right: 1rem;
}
.password-input-field_wrapper {
  position: relative;
}
.view-password svg {
  position: absolute;
  right: 1rem;
  top: 1rem;
  opacity: 0.5;
  cursor: pointer;
}
</style>
